import vue from "vue";

export const fetchCartItem = async (payload) =>
	await vue.axios.post("/cart/cart/view", payload);

export const addToCartService = async (payload) =>
	await vue.axios.post("/cart/cart/add", payload);

export const removeCartService = async (payload) =>
	await vue.axios.post("/cart/cart/remove", payload);

export const finalCheckout = async (payload) => {
	let url = "/checkout/checkout/v2/confirm";
	if (payload.checkout.type === "STRIPE" || payload.checkout.type === "PAYPAL") {
		url = "/checkout/checkout/v2/confirm?ver=3";
	}
	const res = await vue.axios.post(url, payload);
	return res;
};
export const finalTransactionBenefits = async (payload) =>
	await vue.axios.post("/order/api/v1/order/reward-estimate", payload);

export const fetchCoupon = async () =>
	await vue.axios.get("/promo/promotion/get/user/tenant/all");

export const clearCart = async () => await vue.axios.get("/cart/cart/empty");

export const fetchBankDetails = async (payload) =>
	await vue.axios.get(`/payments/payout/cashfree/get-beneficiary/${payload}`);

export const createOrder = async (payload) => {
	const res = await vue.axios.post("/order/api/v2/order/create", payload);
	return res;
};
export const orderValidation = async (payload) => {
	const res = await vue.axios.post("/order/api/v2/order/verify", payload);
	return res;
};
export const stripeCheckoutApi = async (payload) => {
	const res = await vue.axios.post(
		"/payments/stripe/v1/checkout-stripe-pay",
		payload
	);
	return res;
};
export const getPartnerInfo = async (payload) => {
	const res = await vue.axios.get(`/cap/users/partner/get-preferences/${payload}`);
	return res.data.response;
};
// export const storeListApi = async (id) => {
// 	const res = await vue.axios.get(`/cap/users/partner/list/?parent=${id}`);
// 	return res.data.response;
// };
export const storeListApi = async (payload) => {
	const res = await vue.axios.post(`/cap/users/partner/nearby`, payload);
	return res.data.response;
};

export const sellerDetailsApi = async (providerId) => {
	const res = await vue.axios.get(`/cap/users/partner/get-detail/${providerId}`);
	return res;
};
